module.exports = __webpack_public_path__ + "img/car-side-solid.6941afd8.svg";